export const handleStopPropagation = (e: {
  stopPropagation?: VoidFunction;
}): void => {
  e.stopPropagation?.();
};

export const handlePreventDefault = (e: {
  preventDefault?: VoidFunction;
}): void => {
  e.preventDefault?.();
};
